import { render, staticRenderFns } from "./sTasks.vue?vue&type=template&id=ba4781ac"
import script from "./sTasks.vue?vue&type=script&lang=js"
export * from "./sTasks.vue?vue&type=script&lang=js"
import style0 from "./sTasks.vue?vue&type=style&index=0&id=ba4781ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports